import CheckBox from '@/components/basicComponents/checkbox';
import { ErrorText } from '@/components/basicComponents/input';
import Label from '@/components/basicComponents/label';
import { buildTestId } from '@/lib/utils/testIds';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { IRenderTemplateField } from '../../types';
import { themeVar } from '@/styles/theme';

interface CheckboxProps {
  control: any;
  field: IRenderTemplateField;
  pageName?: string;
  ignoreRequired: boolean;
}

export const Checkbox = ({ field, control, pageName = '', ignoreRequired }: CheckboxProps) => {
  return (
    <div>
      <Controller
        name={`${pageName}.${field.name}`}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <CheckboxComponentWrapper>
              {field?.label && (
                <Label size="md" required={!!field?.validation?.required && !ignoreRequired}>
                  {field?.label || ''}
                </Label>
              )}
              <CheckboxWrapper id={field.name} onClick={() => onChange(!value)}>
                <CheckBox id={field.name} isActive={!!value} data-testid={field.name ? buildTestId('signature-packet', pageName, field.name) : undefined} /> {field?.config?.optionLabel || ''}
              </CheckboxWrapper>
            </CheckboxComponentWrapper>
            {error?.message && <ErrorText size="md">{error?.message}</ErrorText>}
          </>
        )}
      />
    </div>
  );
};

const CheckboxComponentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 15px 0 10px 0;
`;

const CheckboxWrapper = styled.div`
  cursor: pointer;
  display: flex;
  gap: 9px;
  color: ${themeVar('font.base')};
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
`;
